import { AiFillAppstore } from "react-icons/ai";
import {  FaBrain} from "react-icons/fa";
import { SiProgress} from "react-icons/si";
import { CgWebsite } from "react-icons/cg";
import { FaUikit } from "react-icons/fa";
import { MdDesignServices } from "react-icons/md";

// Features Data
export const featuresData = [
  {
    id: 1,
    icon: <AiFillAppstore />,
    title: "App Development",
    des: "Currently developing a mobile application aimed to offering solution for waste management systems",
  },
  {
    id: 2,
    icon: <CgWebsite />,
    title: "Web Development",
    des: "Expertise in React-based web development and have successfully contributed to multiple projects in this domain.",
  },
  {
    id: 3,
    icon: <SiProgress />,
    title: "Digital Marketing",
    des: "Hands-on experience in this field for over four years worked with many brands, specializing in social media marketing",
  },
  {
    id: 4,
    icon: <FaUikit />,
    title: "UI/UX Designer",
    des: "Passionate about both designing and marketing, which has equipped me with substantial knowledge in this field",
  },
  {
    id: 5,
    icon: <MdDesignServices />,
    title: "Graphic Designer",
    des: "Excel in using Adobe Creative Suite, particularly in Photoshop and Illustrator. Can Review my portfolio on Behance",
  },
  {
    id: 6,
    icon: <FaBrain />,
    title: "Content Creator",
    des: "Through videography and video editing, expressing my creativity. Check my Instagram Reels side to witness my work.",
  },
];
